import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { StringParam, useQueryParam } from 'use-query-params';
import { Card, Container } from 'react-bootstrap';

import * as S from './styles';

import { Loading, BreadCrumb } from '@atoms';
import { NoResult } from '@molecules';

import { FAQ_TOPICS } from '@components/pages/FaqPage/queries';
import { faqTopics } from '@components/pages/FaqPage/__generated__/faqTopics';
import { faqUrl } from '@src/app/routes';

const FaqSearchPage = () => {
  const [query, setQuery] = useQueryParam('q', StringParam);

  const { data, loading } = useQuery<faqTopics>(FAQ_TOPICS, {
    variables: {
      first: 5,
      query,
    },
    onCompleted: (data) => {},
  });

  const breadCrumbData = [
    {
      name: 'FAQ',
      link: faqUrl,
    },
    {
      name: 'SEARCH',
    },
  ];

  if (loading) {
    return <Loading />;
  }

  return data?.faqTopics?.edges?.length > 0 ? (
    <Container>
      <BreadCrumb data={breadCrumbData} />
      {0 < data.faqTopics.totalCount ? (
        data.faqTopics.edges.map((topic, i) => {
          return (
            <Card key={i}>
              <S.RedCard>{topic.node.title}</S.RedCard>
              <Card.Body>
                <div dangerouslySetInnerHTML={{ __html: topic.node.content }}></div>
              </Card.Body>
            </Card>
          );
        })
      ) : (
        <NoResult />
      )}
    </Container>
  ) : (
    <NoResult />
  );
};

export { FaqSearchPage };
